import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { AuthStorageService, BaseSiteService, UserIdService } from '@spartacus/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface GetPreferencesCodesPayload {
  preferenceCodes?: any;
  fields?: any;
}

export interface PostRequestDeletePayload {
  fields?: any;
  userID?: any;
}

@Injectable({
  providedIn: 'root',
})
export class MyaccountB2bunitService {
  baseSite$: Observable<string> = this.baseService.getActive();
  userCurrent$: Observable<string> = this.auth.getUserId();
  occUrl = this.meta.getTag('name=occ-backend-base-url');
  url = `${this.occUrl?.content}${environment.prefix}${this.baseSiteId}`;
  headers = new HttpHeaders().set('Content-Type', 'application/json');
  isPaymentDetailsLoaded = new BehaviorSubject<boolean>(false);

  constructor(
    protected http: HttpClient,
    protected auth: UserIdService,
    protected authStorageService: AuthStorageService,
    protected baseService: BaseSiteService,
    private meta: Meta
  ) {}
  get baseSiteId(): string {
    let baseSiteId = '';
    this.baseSite$.pipe(take(1)).subscribe((baseSiteData) => (baseSiteId = baseSiteData));
    return baseSiteId;
  }

  get userCurrent(): string {
    let userCurrent = '';
    this.userCurrent$.pipe(take(1)).subscribe((userId) => (userCurrent = userId));
    return userCurrent;
  }

  get tokenId(): string {
    let tokenId = '';
    this.authStorageService
      .getToken()
      .pipe(take(1))
      .subscribe((tokenIdData: any) => (tokenId = tokenIdData.access_token));
    return tokenId;
  }

  getB2BManagement(): Observable<any> {
    this.isPaymentDetailsLoaded.next(false);
    return this.http
      .get(`${this.url}/users/${this.userCurrent}/management/b2bunit`, {
        headers: this.headers,
      })
      .pipe(
        map((data) => data),
        catchError(this.errorHandlr)
      );
  }
  getManagedPreferences(): Observable<any> {
    return this.http
      .get(`${this.url}/users/${this.userCurrent}/management/preferences`, {
        headers: this.headers,
      })
      .pipe(
        map((data) => data),
        catchError(this.errorHandlr)
      );
  }
  getB2BUser(payload: GetPreferencesCodesPayload): Observable<any> {
    const params = new HttpParams().set('fields', payload.fields);

    return this.http
      .get(`${this.url}/users/${this.userCurrent}`, {
        params,
        headers: this.headers,
      })
      .pipe(
        map((data) => data),
        catchError(this.errorHandlr)
      );
  }
  patchManagedPreferences(payload: GetPreferencesCodesPayload): Observable<any> {
    const body = payload.preferenceCodes;
    return this.http
      .patch(`${this.url}/users/${this.userCurrent}/management/preferences`, JSON.stringify(body), {
        headers: this.headers,
      })
      .pipe(
        map((data) => data),
        catchError(this.errorHandlr)
      );
  }

  requestDeleteAccount(payload: PostRequestDeletePayload): Observable<any> {
    const userId = payload.userID;
    const params = new HttpParams().set('fields', payload.fields);

    return this.http
      .post(`${this.url}/units/${userId}/account`, {
        params,
        headers: this.headers,
      })
      .pipe(
        map((data) => data),
        catchError(this.errorHandlr)
      );
  }

  plannedOrderEnabled(): Observable<boolean> {
    return this.http
      .get(`${this.url}/users/${this.userCurrent}/management/b2bunit`, {
        headers: this.headers,
      })
      .pipe(
        map((data: any) => {
          return data?.plannedOrderEnabled;
        }),
        catchError(this.errorHandlr)
      );
  }

  errorHandlr(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
